// extracted by mini-css-extract-plugin
export default {"container":"ItemCard_container__ko5i+","imgContainer":"ItemCard_imgContainer__YL6St","button":"ItemCard_button__pW+uf","name":"ItemCard_name__g8npf","types":"ItemCard_types__-jYxD"};